import { CDN } from "../enums/CDN";

export class Country {
    /** E.g.: 'nl-NL' **/
    private _flashLocaleId: string = "";

    /** Will set to true as soon as additional unicode ranges are added. **/
    private _useNonLatinCharset: boolean = false;

    constructor(
        public readonly ggsCountryCode: string,
        public readonly ggsLanguageCode: string,
        public readonly browserLanguageCodes: string[],
        public readonly geoIpCodes: string[],
        public readonly flashRuntimeLanguageCodes: string[],
        public readonly utcTimezoneMin: number,
        public readonly utcTimezoneMax: number,
        public readonly cdn: CDN,
        public readonly isDefault: boolean
    ) {
        // Set flashLocaleId, which needed for the numberFormatter & dateTimeFormatter. There are two exceptions: norwegian(1) and chinese(2) languages.
        // 1) We need to set localeId for norwegian additional, because globalization tools of the flash player do not understand our language code.
        // 2) It can be necessary in the future to distinguish between traditional and simplified Chinese, but currently only simplified Chinese (Hans) is used in our games.
        if (this.ggsLanguageCode.toLowerCase() === "zh") {
            this._flashLocaleId = "zh-Hans-CN";
        } else {
            this._flashLocaleId = this.ggsLanguageCode.toLowerCase() + "-" + this.ggsCountryCode.toUpperCase();
        }
    }

    /**
     * Verify if the given <code>timezone</code> is in the UTC timezone range of this country.
     * @param timezone UTC timezone of the user.
     */
    public isUTCTimezoneInRange(timezone: number): boolean {
        return timezone >= this.utcTimezoneMin && timezone <= this.utcTimezoneMax;
    }

    public toString(): string {
        return "ggsCountryCode: '" + this.ggsCountryCode +
            "', ggsLangCode: '" + this.ggsLanguageCode +
            "', flashLangCodes: '" + this.flashRuntimeLanguageCodes +
            "', browserLangCodes: '" + this.browserLanguageCodes +
            "', geoIpCodes: '" + this.geoIpCodes +
            "', timeZoneOffset " + (isNaN(this.utcTimezoneMin) ? "NA" : ("from " + this.utcTimezoneMin + " to " + this.utcTimezoneMax));
    }

    public get useNonLatinCharset(): boolean {
        return this._useNonLatinCharset;
    }

    public set useNonLatinCharset(value: boolean) {
        this._useNonLatinCharset = value;
    }

    public get isLanguageWrittenRightToLeft(): boolean {
        return this.ggsLanguageCode === "ar";
    }

    public get flashLocaleId(): string {
        return this._flashLocaleId;
    }
}
